import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import { CloseIcon } from "./dialogStyle";
import * as themeStyle from "../../../theme";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  title: {
    fontSize: 24,
    color: themeStyle.palette.gunmetal,
    fontFamily: themeStyle.font.mainFont,
    fontWeight: themeStyle.font.mainFontWeight,
    padding: "40px",
    textTransform: "capitalize",
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, closeIconId, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.title} {...other}>
      {children}
      {onClose ? <CloseIcon id={closeIconId} onClick={onClose} /> : <></>}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    color: themeStyle.palette.gunmetal,
    padding: 0,
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: "20px 40px",
  },
}))(MuiDialogActions);

export default function CustomizedDialogs(props) {
  const {
    dialogTitleId = "customized-dialog-title",
    closeIconId,
    handleClose,
    open,
    children,
    title,
    divider,
    maxWidth,
    height,
  } = props;
  let isDividers = divider !== undefined ? false : true;
  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby={dialogTitleId}
      open={open}
      PaperProps={{
        style: {
          maxWidth: maxWidth || "1270px",
          minWidth: "400px",
          height: height || "auto",
        },
      }}
    >
      <DialogTitle
        id={dialogTitleId}
        closeIconId={closeIconId}
        onClose={props.handleClose}
      >
        {title}
      </DialogTitle>
      <DialogContent dividers={isDividers}>{children[0]}</DialogContent>
      <DialogActions>{children[1]}</DialogActions>
    </Dialog>
  );
}
